/**
 * WarningPanel React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import WarningTwoToneIcon from '@material-ui/icons/WarningTwoTone';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';


const styles = theme => ({
    note: {
        padding: 10,
        display: "flex",
        backgroundColor: "#147c9155",
        color: "#ffffff",
        borderRadius: 5
    },
    noteText: {
        alignSelf: "center",
        marginLeft: 10,
        fontSize: 18,
        color: "#ffffff"
    }
});


/**
 * simple panel for warnings
 *
 * @author Jens Gruschel
 */
class WarningPanel extends React.Component {

    render() {

        const { classes } = this.props;

        return (
            <div className={classNames(classes.note, this.props.className)}>
                <WarningTwoToneIcon fontSize="large" style={{float: "left"}}/>
                <Typography component="p" className={classes.noteText}>{this.props.text}</Typography>
            </div>
        );
    }
}

WarningPanel.propTypes = {
    text: PropTypes.string.isRequired
};

export default withStyles(styles)(WarningPanel);